module.exports = __webpack_public_path__ + "assets/img/6.37e81797.jpg";